/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { useLocation } from "react-router-dom";
import {
  GridColDef,
  GridRowParams,
  GridSelectionModel,
  GridCallbackDetails,
  GridColumnHeaderParams,
  GridRowClassNameParams,
  GridValidRowModel,
  GridEventListener,
  GridColumnGroupingModel,
} from "@mui/x-data-grid";
import Processing from "../Processing";
import { StyleDataGrid, NoRowsOverlayWrap } from "./style";
import { useNavigate } from "react-router";
import TablePaginationActions from "./TablePaginationAction";

/**
 * 특정 기능의 경우 Style 로 강제로 disable 처리를 했습니다.
 * ex)header columns menu -> GlobalStyle 의 .MuiDataGrid-menu 참고
 */

export interface Props {
  rows: any;
  columns: GridColDef[];
  totalCount: any;
  loading: any;
  page: any;
  rowHeight?: any;
  rowsPerPage: any;
  rowClickEvent?: (params: GridRowParams) => void;
  checkboxSelection?: boolean;
  onSelectionModelChange?: (
    selectionModel: GridSelectionModel,
    details: GridCallbackDetails<any>
  ) => void;
  onPageSizeChange?: any;
  onPageChange?: any;
  sort?: any;
  handleColumnHeaderClick?: (params: GridColumnHeaderParams) => void;
  onCellClick?: GridEventListener<"cellClick"> | undefined;
  getRowClassName?: (
    params: GridRowClassNameParams<GridValidRowModel>
  ) => string;
  onColumnVisibilityChange?: (params: any) => void;
  columnGroupingModel?: GridColumnGroupingModel;
  // disableClickEventBubbling?: any;
}

const NoRowsOverlay = () => (
  <NoRowsOverlayWrap>No search results</NoRowsOverlayWrap>
);

const LoadingOverlay = () => (
  <NoRowsOverlayWrap>
    <Processing size={40} color="grey" label="loading" />
  </NoRowsOverlayWrap>
);

const CustomDataGrid = ({
  rows,
  columns,
  totalCount,
  loading,
  page,
  rowHeight,
  rowsPerPage,
  rowClickEvent,
  checkboxSelection,
  onSelectionModelChange,
  onPageSizeChange,
  onPageChange,
  sort,
  handleColumnHeaderClick,
  getRowClassName,
  onCellClick,
  onColumnVisibilityChange,
  columnGroupingModel,
}: Props) => {
  const navigate = useNavigate();

  const location = useLocation();

  const customCellClick: GridEventListener<"cellClick"> = (params) => {
    if (params.field === "link") {
      window.open("/templates/" + params.id, "_blank");
    } else if (
      location.pathname.includes("moderation") &&
      params.field === "reviewStatus"
    ) {
      return false;
    } else if (
      params.field === "operation" ||
      params.field === "reviewer" ||
      params.field === "order" ||
      params.field === "details" ||
      params.field === "id" ||
      params.field === "title" ||
      params.field === "editedBy" ||
      params.field === "modify" ||
      params.field === "type" ||
      params.field === "no" ||
      params.field === "update" ||
      params.field === "index" ||
      params.field === "createdAt" ||
      params.field === "ipAddress" ||
      params.field === "details.action" ||
      params.field === "user" ||
      params.field === "details" ||
      params.field === "langAndRegion"
    ) {
      return false;
    } else if (
      location.pathname.includes("moderation") &&
      params.field === "thumbnail"
    ) {
      return false;
    } else {
      navigate("/templates/" + params.id);
    }
  };
  return (
    <StyleDataGrid
      autoHeight
      columnBuffer={2}
      columnThreshold={2}
      rows={rows}
      rowHeight={rowHeight ? rowHeight : 100}
      columns={columns}
      pageSize={rowsPerPage}
      rowCount={totalCount}
      sortingMode="server"
      sortingOrder={[]}
      components={{
        ColumnUnsortedIcon: null,
        NoRowsOverlay,
        LoadingOverlay,
      }}
      getRowHeight={() => (rowHeight ? rowHeight : "auto")}
      paginationMode="server"
      rowsPerPageOptions={
        location.pathname.includes("moderation")
          ? [10, 20, 30, 40, 50]
          : [20, 40, 60, 80, 100]
      }
      onPageSizeChange={onPageSizeChange}
      onPageChange={onPageChange}
      pagination
      hideFooterSelectedRowCount
      loading={loading}
      page={page}
      checkboxSelection={checkboxSelection}
      onSelectionModelChange={onSelectionModelChange}
      onColumnHeaderClick={handleColumnHeaderClick}
      getRowClassName={getRowClassName}
      onCellClick={customCellClick}
      onColumnVisibilityChange={onColumnVisibilityChange}
      disableSelectionOnClick
      {...(columnGroupingModel
        ? {
            columnGroupingModel,
            experimentalFeatures: { columnGrouping: true },
          }
        : {})}
      componentsProps={{
        pagination: {
          ActionsComponent: TablePaginationActions,
        },
      }}
      // onRowClick 대신 onCellClick 이벤트로 활용
      // onRowClick={rowClickEvent}
    />
  );
};

export default CustomDataGrid;
